import { useCollectPaymentMultiContext } from '../../collect-payment-multi.context';
import { CollectPaymentMultiFlow } from '../../collect-payment-multi.types';

export type StepNavigationBaseProps = object;
export type StepNavigationComponent<P extends StepNavigationBaseProps, Extra extends object> = React.ComponentType<{
  body: React.ComponentType<P>;
  extra: Extra;
}>;

export type StepRenderComponent<P extends StepNavigationBaseProps> = React.ComponentType<P>;

export type StepNavigationSwitchProps<P extends StepNavigationBaseProps, Extra extends object> = {
  generic: StepNavigationComponent<P, Extra>;
  body: StepRenderComponent<P>;
  extra?: Extra;
} & {
  [K in CollectPaymentMultiFlow]?: StepNavigationComponent<P, Extra>;
};

export const StepNavigationSwitch = <P extends StepNavigationBaseProps, Extra extends object>({
  generic: Generic,
  select: Select,
  pay: Pay,
  create: Create,
  insert: Insert,
  body,
  extra = {} as Extra,
}: StepNavigationSwitchProps<P, Extra>) => {
  const { flow } = useCollectPaymentMultiContext();

  if (typeof Select == 'function' && flow === 'select') {
    return <Select extra={extra} body={body} />;
  }

  if (typeof Pay == 'function' && flow === 'pay') {
    return <Pay extra={extra} body={body} />;
  }
  if (typeof Create == 'function' && flow === 'create') {
    return <Create extra={extra} body={body} />;
  }

  if (typeof Insert == 'function' && flow === 'insert') {
    return <Insert extra={extra} body={body} />;
  }

  return <Generic extra={extra} body={body} />;
};
